import { servicesQuery } from './servicesQuery';
import { useQueryRefresh } from 'shared/apollo';

export function useServicesQuery() {
  const { data: query, refresh, isLoading } = useQueryRefresh(servicesQuery);
  const data = (query?.services??[]).filter(service => service.version==='v4');
  return { data, refresh, isLoading };
}

